import React, { useState } from 'react';
import Glyph from '../glyphs/Glyph';

interface EmojiMatchGameProps {
  onComplete: (score: number) => void;
}

const QUESTIONS = [
  { glyph: 'angry', answer: 'כעס' },
  { glyph: 'laugh', answer: 'צחוק' },
  { glyph: 'cry', answer: 'עצב' },
  { glyph: 'scared', answer: 'פחד' },
  { glyph: 'love', answer: 'אהבה' },
  { glyph: 'sleepy', answer: 'עייפות' },
];

export default function EmojiMatchGame({ onComplete }: EmojiMatchGameProps) {
  const [qIndex, setQIndex] = useState(0);
  const [score, setScore] = useState(0);

  const currentQ = QUESTIONS[qIndex];

  // Memoize options to prevent re-shuffling on every render
  const options = React.useMemo(() => {
    const others = ['בלבול', 'שמחה', 'גועל', 'הפתעה', 'בוז', 'שלווה']
      .filter(o => o !== currentQ.answer)
      .sort(() => Math.random() - 0.5)
      .slice(0, 2);
    return [currentQ.answer, ...others].sort(() => Math.random() - 0.5);
  }, [currentQ]);

  const handleAnswer = (isCorrect: boolean) => {
    // 2 points per correct answer as requested
    const pointsToAdd = isCorrect ? 2 : 0;
    
    // Update score immediately only if correct
    if (isCorrect) setScore(s => s + pointsToAdd);
    
    if (qIndex + 1 < QUESTIONS.length) {
      setQIndex(i => i + 1);
    } else {
      // Pass total score including the current one if correct
      onComplete(score + pointsToAdd);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 text-foreground h-full dir-rtl">
        <h2 className="text-xl font-bold mb-8 flex items-center gap-2">
            <Glyph name="joy" size={26} /> זהה את הרגש
        </h2>

        <div className="mb-12 animate-bounce cursor-pointer hover:scale-110 transition-transform">
            <Glyph name={currentQ.glyph} size={120} />
        </div>

        <div className="grid grid-cols-1 gap-4 w-full max-w-xs">
            {options.map((opt, i) => (
                <button 
                    key={i}
                    onClick={() => handleAnswer(opt === currentQ.answer)}
                    className="p-4 bg-muted hover:bg-muted border border-border rounded-xl text-lg font-bold transition-all active:scale-95"
                >
                    {opt}
                </button>
            ))}
        </div>
        
        <div className="mt-8 text-muted-foreground text-sm">
            שאלה {qIndex + 1} מתוך {QUESTIONS.length}
        </div>
    </div>
  );
}
